import { DeliveryWindow, Id } from '@typings';

import { isDefined } from '../utils/is';

import { showroomApi } from './api';

export const fetchAllDeliveryWindows = async () => showroomApi.POST('/delivery-windows')({ data: {} });

export const fetchOrderSpecificDeliveryWindows = async (orderId?: Id) =>
  showroomApi.POST('/delivery-windows')({
    data: isDefined(orderId) ? { order: orderId } : {},
  });

export const fetchBuyerAndOrderSpecificDeliveryWindows = async (buyerId: Id, orderId?: Id) =>
  showroomApi.POST('/delivery-windows')({
    data: {
      buyer: buyerId,
      ...(isDefined(orderId) && { order: orderId }),
    },
  });

export interface DeliveryWindowSearchDataDTO {
  limit: number;
  page: number;
  name?: string;
  status?: DeliveryWindow.Status;
  sortBy?: DeliveryWindow.SortByDate;
  marketId?: DeliveryWindow.Id;
  sortOrder?: DeliveryWindow.SortOrder;
}

export const getDeliveryWindows = async (data: DeliveryWindowSearchDataDTO) => showroomApi.QUERY_POST('/delivery-windows/search')({ data });
